<div
  class="tw-reset tw-relative tw-mx-4 tw-grid tw-h-dvh tw-place-items-center md:tw-mx-0"
>
  <div
    class="tw-absolute tw-top-14 tw-w-full tw-max-w-full tw-rounded-2xl tw-bg-white tw-p-6 tw-pb-4 tw-shadow-xl md:tw-w-[488px]"
    role="dialog"
    aria-labelledby="title"
  >
    @if (vm$ | async; as vm) {
      <div class="tw-flex tw-flex-col">
        <h4
          class="tw-mb-4 tw-font-extrabold tw-text-neutral-900"
          id="title"
          tabindex="-1"
          #titleElement
        >
          {{ tag.title }}
        </h4>
        <div class="tw-text-neutral-80 tw-max-w-md tw-pb-2 tw-text-xs">
          <div class="tw-text-base tw-font-extrabold tw-text-neutral-900">
            {{ translateService('Description', 'Core_descriptionLabel') }}
          </div>
          <div
            #textContent
            [class]="
              twMerge(
                'tw-text-content tw-overflow-hidden tw-transition-all tw-duration-300',
                expanded() ? 'tw-line-clamp-none' : 'tw-line-clamp-1'
              )
            "
          >
            {{ getDescription(vm) }}
          </div>

          <!-- Show More button (only visible if content is clamped) -->
          @if (isClamped()) {
            <div class="tw-w-full">
              <button
                (click)="expanded.set(!expanded())"
                class="tw-focus:outline-none tw-mt-2 tw-flex tw-font-semibold tw-text-blue-800"
              >
                {{
                  expanded()
                    ? translateService('Show Less', 'Core_showLessButtonText')
                    : translateService('Show More', 'Core_showMoreButtonText')
                }}
                <da-icon
                  type="solid"
                  class="tw-mx-1 tw-size-4 tw-text-blue-800"
                  [icon]="expanded() ? 'chevron-up' : 'chevron-down'"
                  [solidSize]="20"
                ></da-icon>
              </button>
            </div>
          }
        </div>

        <div class="tw-flex-grow tw-overflow-scroll tw-py-4">
          @for (type of vm.enabledRatingTypes; track trackByFn) {
            <div data-dgat="tag-rating-overview-608">
              <dgx-tag-rating-button-v3
                [type]="type"
                [ownerIsViewing]="true"
                [tag]="vm.tag"
                [tagRatingDetails]="vm.ratingDetails"
                [availableRatingTypes]="vm.availableRatings"
                [trackingLocation]="trackingLocation"
                [allCheckpoints]="vm.allCheckpoints"
                [isEvaluable]="vm.isEvaluable"
                (onOpenOtherModal)="updateModalStack()"
              ></dgx-tag-rating-button-v3>
            </div>
          }
        </div>
        <div
          class="tw-flex tw-flex-col tw-justify-end tw-gap-2 md:tw-flex-row md:tw-gap-4"
        >
          <button class="tw-btn-primary tw-btn-medium" (click)="close()">
            {{ translateService('Done', 'Core_Done') }}
          </button>
        </div>
      </div>
    } @else {
      <ul class="tw-mb-2 tw-p-2">
        <dgx-skeleton type="title"></dgx-skeleton>
        <div class="tw-pt-2">
          <dgx-skeleton type="mediumTitle"></dgx-skeleton>
          <dgx-skeleton type="list" [rows]="2"></dgx-skeleton>
        </div>
        <div class="tw-pt-2">
          <dgx-skeleton type="mediumTitle"></dgx-skeleton>
          <dgx-skeleton type="list" [rows]="2"></dgx-skeleton>
        </div>
      </ul>
    }
  </div>
</div>
